import { useContext, useEffect, useState } from "react";
import { apis } from "../../../services/alm";
import { useTranslation } from "react-i18next";
import { constants } from "../../../assets/constants/constants";
import { useNavigate } from "react-router-dom";
import { AppContext } from "../../../context/AppProvider";

const Achievements = ({ goToBadgesRef }: any) => {
  const [isBadgeList, setIsBadgeList] = useState<any>([]);
  const [isCompleted, setIsCompleted] = useState<any>();
  const { state } = useContext<any>(AppContext);

  const { t } = useTranslation();
  const navigate = useNavigate();

  useEffect(() => {
    const getAllBadges = async () => {
      const result = await apis.getBadgeList();
      const badgesList = result?.data?.filter(
        (item: any) => item?.attributes?.state !== constants.RETERIED
      );
      setIsBadgeList(badgesList);
    };
    getAllBadges();

    const getUserbadge = async (id: any) => {
      const result = await apis.getBadgesByuserId(id);
      const completedData = result?.data
        ?.filter(
          (res: any) => res?.attributes?.modelType == constants.LEARNING_OBJECT
        )
        .filter((item: any) => item?.attributes?.dateAchieved)
        .map((item: any) => {
          return {
            badgeId: item?.relationships?.badge?.data?.id,
            programId: item?.relationships?.model?.data?.id,
          };
        });
      setIsCompleted(completedData);
    };
    if (isBadgeList && state?.user?.userId) {
      getUserbadge(state?.user?.userId);
    }
  }, [state?.user?.userId]);
  const handleRedirection = (res: any) => {
    if (res?.programId === state?.fundamentalId &&res?.programId !== undefined &&
      state?.fundamentalId !== undefined ) {
      navigate(`/program/learningProgram`);
    } else if (res?.programId) {
      navigate(`/program/${res?.programId}`);
    } else {
      return;
    }
  };
  return (
    <>
      <div className="w-[100%] mx-auto xl:px-32 lg:px-8 md:px-8 px-5 py-6 md:py-14">
        <div className="md:flex md:items-center md:justify-between mb-4 md:mb-0">
          <div className="min-w-0 flex-1  md:pb-10">
            <h1
              ref={goToBadgesRef}
              className="scroll-m-20 tracking-tight leading-7 text-2xl lg:text-3xl xl:text-4xl font-barlowLight font-light"
              dangerouslySetInnerHTML={{ __html: t("MyStance.achievements") }}
            />
          </div>
        </div>
        <div className="grid xl:grid-cols-5 lg:grid-cols-3 md:grid-cols-3 gap-4 gap-y-10 lg:gap-x-3">
          {isBadgeList?.map((res: any) => {
            return (
              <>
                <div
                  onClick={() =>
                    handleRedirection(
                      isCompleted?.filter(
                        (item: any) => item?.badgeId === res.id
                      )[0],
                    )
                  }
                  className=" md:min-w-[211px] flex flex-col justify-center font-medium rounded-2xl text-sm px-8 py-6 me-2 mb-2 dark:card-gray"
                >
                  <div
                    className={`program-badge-lg ${
                      isCompleted?.filter(
                        (item: any) => item?.badgeId === res.id
                      )[0]
                        ? "completed-program-badge"
                        : ""
                    } m-auto mx-auto`}
                  >
                    <img
                      src={res?.attributes?.imageUrl}
                      className={`program-badge-midimg max-w-[70px] max-h-[78px] w-[70px]  lg:max-w-[88px] lg:max-h-[78px] lg:w-[88px] h-auto rounded-md ${
                        isCompleted?.filter(
                          (item: any) => item?.badgeId === res.id
                        )[0]
                          ? "yellow cursor-pointer "
                          : "grey"
                      }`}
                      alt="no Image"
                    />
                  </div>
                  <div className="pt-4 pb-0 h-20">
                    <p
                      className={`text-xl font-barlowLight ${
                        isCompleted?.filter(
                          (item: any) => item?.badgeId === res.id
                        )[0]
                          ? ""
                          : "opacity-50"
                      } text-center line-clamp-2 `}
                    >
                      {res?.attributes?.name?.includes("_")
                        ? res?.attributes?.name.split("_")[1]
                        : res?.attributes?.name}
                    </p>
                  </div>
                </div>
              </>
            );
          })}
        </div>
      </div>
    </>
  );
};

export default Achievements;
